import { Box, Center, HStack, Spacer, Stack, Text } from "@chakra-ui/react";
import { useContaxt } from "../../context/Context";

export function AboutText(props) {
  const { text, side, image, marginT = "100px", textWidth, ...rest } = props;
  const { variant } = useContaxt();

  return (
    <>
      <Center w={"100%"} mt={marginT}>
        {variant === "lg" ? (
          <HStack align={"flex-start"} w={1200} {...rest}>
            {side === "left" && (
              <>
                {image}
                <Spacer />{" "}
              </>
            )}
            <Box w={textWidth} color={"#1A202C"} fontSize={"18px"}>
              {text}
            </Box>
            {side === "right" && (
              <>
                {" "}
                <Spacer /> {image}
              </>
            )}
          </HStack>
        ) : (
          <Center>
            <Stack w={"90vw"} {...rest}>
              <Center>{image}</Center>
              <Box w={textWidth} color={"#1A202C"} fontSize={"18px"}>
                {text}
              </Box>
            </Stack>
          </Center>
        )}
      </Center>
    </>
  );
}
